import { render, staticRenderFns } from "./TipsModel.vue?vue&type=template&id=5b6d2835&scoped=true"
import script from "./TipsModel.vue?vue&type=script&lang=js"
export * from "./TipsModel.vue?vue&type=script&lang=js"
import style0 from "./TipsModel.vue?vue&type=style&index=0&id=5b6d2835&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d2835",
  null
  
)

export default component.exports